<div
    class="tw-py-[30px] tw-flex tw-flex-col tw-gap-[42px] tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-bg-[#F8F9FE]"
>
    <div class="tw-flex tw-flex-col tw-gap-[18px]">
        <span
            class="lg:tw-text-[28px] md:tw-text-[24px] tw-text-[22px] tw-leading-[140%] tw-font-bold tw-text-[#024B3F]"
            >{{ data?.title }}</span
        >
        <span
            class="tw-text-black tw-text-[14px] tw-font-normal tw-leading-[22px] default-html"
            [innerHTML]="data?.description"
        ></span>
        <div
            class="tw-border tw-border-[#7B7575] tw-rounded-[10px] tw-px-[24px] tw-h-[64px] tw-flex tw-flex-row tw-items-center tw-gap-[12px]"
        >
            <mat-icon
                aria-hidden="false"
                aria-label="Prev Button"
                fontIcon="search"
                class="tw-text-[#4B6EEC]"
                >chevron_left</mat-icon
            >
            <input
                class="tw-h-[32px] tw-text-[16px] tw-font-semibold placeholder:tw-text-[#7B7575] tw-text-black tw-w-full placeholder:tw-opacity-70 tw-bg-transparent"
                placeholder="Search for any product"
                [(ngModel)]="searchText"
                (input)="onSearch()"
            />
        </div>

        <!-- Search Results -->
        <div class="tw-flex tw-flex-col tw-gap-1" *ngIf="searchText">
            <span class="tw-text-2xl tw-font-semibold">{{
                resultCountText
            }}</span>
            <span
                *ngIf="dataFound"
                class="tw-text-base tw-font-semibold tw-text-gray-500"
            >
                Based on your search
            </span>
        </div>
        <div class="tw-space-y-12 tw-mt-[25px] md:tw-mt-[15px]">
            <!-- Grid for loop over products (5 items per row) -->
            <div
                class="tw-grid lg:tw-grid-cols-5 md:tw-grid-cols-4 tw-grid-cols-1 tw-gap-[13px] tw-items-stretch"
            >
                <div
                    *ngFor="let product of filteredFlatProducts"
                    class="tw-h-full"
                >
                    <app-card-type-2
                        [gaPrefix]="gaPrefix"
                        [image]="product.image"
                        [title]="product.title"
                        [description]="product.description"
                        [buttonText]="product.buttonText"
                        (buttonClick)="openLink(product.url)"
                    ></app-card-type-2>
                </div>
            </div>
        </div>
    </div>
</div>
